import { render } from "./DesktopImages.vue?vue&type=template&id=5719c280"
import script from "./DesktopImages.vue?vue&type=script&lang=js"
export * from "./DesktopImages.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__